import { render, staticRenderFns } from "./TgGameName.vue?vue&type=template&id=5c17bdb1"
import script from "./TgGameName.vue?vue&type=script&lang=js"
export * from "./TgGameName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports